module.exports = require('./_global');



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_path.js
// module id = 285
// module chunks = 113